<template>
  <div>
    <!-- <pre>{{ Produto }} {{ MateriaPrima }}</pre> -->
    <div class="row-1" v-if="configInputs != 1">
      <div class="one">
        <label class=""> Código do Produto Relacionado </label>
        <input
          v-model="setCodProduto"
          v-maska="['##.###.######.##-##', '']"
          :class="[
            'field',
            'default_field_width',
            { error: v$.setCodProduto.$error && listaOficial.length == 0 },
          ]"
          placeholder="Digite o código"
        />

        <div
          class="text-red"
          v-if="v$.setCodProduto.$error && listaOficial.length == 0"
        >
          O campo Descrição é obrigatório.
        </div>
        <div class="text-red" v-if="validationProduct === true">
          Código do Produto não encontrado no Sap.
        </div>

        <datalist id="mylist">
          <div v-for="l in lista_pro" :key="l.id">
            <option :value="l.cp">
              {{ l.p }}
            </option>
          </div>
        </datalist>
      </div>

      <div class="one">
        <label class=""> Descrição do Produto Relacionado</label>
        <div class="description-section">
          <input
            v-model="Produto.Desc"
            type="text"
            :class="['field', 'large_field_width']"
            :placeholder="
              loadingdescproduct === 'Não encontrado' ||
              loadingdescproduct === 'Erro'
                ? loadingdescproduct
                : loadingdescproduct + dotsProduct
            "
            disabled
          />
          <div>
            <div class="btn-produto">
              <button @click.prevent="verifyfields" class="btn-button-produto">
                Adicionar Produto
                <div class="sum"></div>
              </button>
            </div>
          </div>
        </div>
        <div
          class="text-red"
          v-if="loadingdescproduct == 'Aguardando' && listaOficial.length === 0"
        >
          Esse campo deve estar preenchido!
        </div>
      </div>
      <!-- <div class="one">
        <label class="">
          Código de Matéria-Prima
        </label>
        <input
          v-model="setCodMateriaPrima"
          list="mylistMP"
          v-maska="['#.#.##.##.#####', '']"
          :class="[
            'field', 'default_field_width',
            { error: v$.setCodMateriaPrima.$error && listaOficial.length == 0 },
          ]"
          placeholder="Digite o código"
        />

        <div
          class="text-red"
          v-if="v$.setCodMateriaPrima.$error && listaOficial.length == 0"
        >
          O campo Descrição é obrigatório.
        </div>
        <div class="text-red" v-if="validationFeedstock === true">
          Código da Matéria-Prima não encontrada no Sap.
        </div>

        <datalist id="mylistMP">
          <div v-for="l in lista_mp" :key="l.id">
            <option :value="l.cmp">
              {{ l.desc }}
            </option>
          </div>
        </datalist>
      </div>  -->

      <!-- <div class="one">
        < <label class=""> Descrição de Matéria Prima </label> 
        <div style="display: flex;align-items: center; gap: 1.5rem;">
          < <div>
            <input
              :type="tipo"
              v-model="MateriaPrima.Desc"
              :class="['field', 'default_field_width']"
              :placeholder="(loadingdescfeedstock === 'Não encontrado' || loadingdescfeedstock === 'Erro')
              ? loadingdescfeedstock
              : loadingdescfeedstock + dotsFeedstock"
              disabled
            />
            <div
            class="text-red"
            v-if="loadingdescfeedstock == 'Aguardando' && listaOficial.length === 0">
            Esse campo deve estar preenchido!
            </div>
          </div> 
          <div>

            <div
            style="height: 2.5rem;"
            v-if="loadingdescfeedstock == 'Aguardando' && listaOficial.length === 0">
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <label
      class=""
      v-if="listaOficial != 0"
      style="margin-bottom: 1rem !important"
    >
      Listagem de Produtos Relacionados
    </label>
    <div class="row-1" v-if="listaOficial != 0">
      <!-- <TableProdutoAndMateria :lista="lista" /> -->
      <div class="tableHistorico" style="border-radius: 0.5rem">
        <table cellpadding="0" class="table">
          <thead v-show="configInputs == 1" class="header">
            <tr>
              <td class="field-table">Nº</td>
              <th class="field-table">Código do Produto</th>
              <th class="field-table">Produto</th>
              <th class="field-table">Código Materia Prima</th>
              <th class="field-table">Materia Prima</th>
            </tr>
          </thead>
          <tbody v-for="(l, index) in listaOficial" :key="l.idp">
            <tr>
              <td style="font-weight: 600">{{ index + 1 }}.</td>
              <td data-title="Código  Produto">{{ l.cp }}</td>
              <td data-title="Produto">{{ l.p }}</td>

              <td data-title="Código Matéria Prima">{{ l.cmp }}</td>
              <td data-title="Matéria Prima">{{ l.mp }}</td>

              <td v-if="configInputs != 1" class="btnDelete">
                <button @click="excluir(l.idpm)" type="button"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { sap } from "../../../../../../http";
import InputI1E from "../../../../../Inputs-defaults/Inp-1-emit.vue";
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
import InputDataList from "../../../../../Inputs-defaults/Inp-Datalist-emit.vue";
import TableProdutoAndMateria from "../../../../../Tables/TableProdutoAndMateria.vue";
import Swal from "sweetalert2";
export default {
  components: { InputI1E, InputDataList, InputI1, TableProdutoAndMateria },
  props: {
    configInputs: Number,
  },
  async created() {
    // materiaprima.data.results.map((item, index) => {
    //   this.lista_mp.push({
    //     id: index,
    //     cmp: item.ItemCode,
    //     desc: item.ItemName
    //   })
    // })
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
      this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
    }
    // this.$store.commit("SetLoading", false); // Tira o loading
  },
  data() {
    return {
      dotsProduct: "",
      dotsFeedstock: "",
      intervalProduct: null,
      intervalFeedstock: null,
      validationFeedstock: false,
      validationProduct: false,
      loadingdescproduct: "Descrição automática do SAP",
      loadingdescfeedstock: "Descrição",
      v$: useVuelidate(),
      listaOficial: [],
      getProduto: Object,
      // getMateriaPrima: Object,
      // setCodMateriaPrima: "",
      setCodProduto: "",
      contProAndMat: 0,
      Produto: {
        Cod: "",
        Desc: "",
      },

      //  Lista de Produto
      lista_pro: [],

      // Lista de Materia Prima
      lista_mp: [],
    };
  },

  validations() {
    return {
      setCodProduto: {
        // required,
        // minLength: minLength(4),
      },
      // setCodMateriaPrima: {
      //   // required,
      //   // minLength: minLength(4),
      // },
    };
  },

  methods: {
    startLoadingDotsProduct() {
      this.dotsProduct = "";
      this.intervalProduct = setInterval(() => {
        if (this.dotsProduct.length >= 3) {
          this.dotsProduct = "";
        } else {
          this.dotsProduct += ".";
        }
      }, 500);
    },
    stopLoadingDotsProduct() {
      clearInterval(this.intervalProduct);
      this.dotsProduct = "";
    },

    startLoadingDotsFeedstock() {
      this.dotsFeedstock = "";
      this.intervalFeedstock = setInterval(() => {
        if (this.dotsFeedstock.length >= 3) {
          this.dotsFeedstock = "";
        } else {
          this.dotsFeedstock += ".";
        }
      }, 500);
    },
    stopLoadingDotsFeedstock() {
      clearInterval(this.intervalFeedstock);
      this.dotsFeedstock = "";
    },
    async mapProduct(codigo) {
      // Se o input estiver vazio, limpa os dados e interrompe
      if (codigo.trim() === "") {
        this.Produto.Desc = "";
        this.validationProduct = false;
        return;
      }

      try {
        const { data: productOne } = await sap.get(`/cod_product`, {
          params: {
            unidade: "JPA",
            cod_product: codigo,
          },
        });

        // Verifica se a resposta contém os dados esperados
        if (!productOne || !productOne.codigo_produto) {
          this.Produto.Desc = "";
          this.validationProduct = true;
          return;
        }

        // Se encontrado, atualiza os dados do produto
        this.Produto.Cod = productOne.codigo_produto;
        this.Produto.Desc = productOne.descricao_produto;
        this.validationProduct = false;
      } catch (error) {
        console.error("Erro ao buscar o produto:", error);
        this.Produto.Desc = "";
        this.validationProduct = true;
      }
    },
    //   async mapFeedstock(feedstock) {
    //     this.$store.commit("SetLoading", true); // insere o loading

    //     if (feedstock.trim() === "") {
    //       this.validationFeedstock = false;
    //       this.$store.commit("SetLoading", false);
    //       return;
    //     }
    // try {
    //       const { data: feedstockOne } = await sap.get(`/raw-material`, {
    //         params: {
    //           unidade: "MAO",
    //           material_code: feedstock,
    //         },
    //       });

    //       // if (!feedstockOne) {
    //       //   this.$store.commit("SetLoading", false);
    //       //   this.MateriaPrima.Desc = "";
    //       //   this.validationFeedstock = true;
    //       //   return;
    //       // }

    //       this.MateriaPrima.Cod = feedstockOne.results[0].itemCode;
    //       this.MateriaPrima.Desc = feedstockOne.results[0].itemName;
    //       this.validationFeedstock = false;

    //       this.$store.commit("SetLoading", false);
    //     } catch (error){
    //       console.error("Erro ao buscar a matéria prima:", error);
    //       this.MateriaPrima.Desc;
    //       this.validationFeedstock = true;
    //     } finally {
    //       this.$store.commit("SetLoading", false);
    //     }
    //   },
    async addProduto() {
      const lista = {
        idpm: (this.contProAndMat += 1),
        idp: this.getProduto.id,
        cp: this.Produto.Cod,
        m: this.getProduto.m,
        p: this.Produto.Desc,
        // idmp: this.getMateriaPrima.id,
        // cmp: this.MateriaPrima.Cod,
        // mp: this.MateriaPrima.Desc,
      };
      if (!this.Produto.Cod) {
        const isFormCorrect = await this.v$.$validate();
        return isFormCorrect;
      } else {
        this.listaOficial.push(lista);
        this.$emit("sendListaDeProdutos", this.listaOficial);
        this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
        this.resetCampos();
      }
    },
    excluir(id) {
      const index = this.listaOficial.findIndex(
        (element) => element.idpm === id
      );

      this.listaOficial.splice(index, 1);
      this.$emit("sendListaDeProdutos", this.listaOficial);
      this.$store.commit("MutationSetDataProdutosUpdate", this.listaOficial);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.Produtos) {
        dataQuery.Produtos.map((element, index) => {
          this.listaOficial.push({
            idpm: index,
            id_pm_update: element.ID,
            idp: element.ID,
            cp: element.COD_PRODUTO,
            p: element.DESC_PRODUTO,
            idmp: element.ID,
            cmp: element.COD_MATERIA_PRIMA,
            mp: element.DESC_MATERIA_PRIMA,
          });

          this.contProAndMat = index;
        });
      }
    },

    verifyfields() {
      if (this.Produto.Cod == "" || this.Produto.Desc == "") {
        Swal.fire({
          icon: "error",
          title: "Campos obrigatórios",
          text: 'Preencha todos os campos de "Produtos" antes de continuar.',
          confirmButtonColor: "var(--green)",
          confirmButtonText: "Ok",
        });
      } else {
        this.addProduto();
      }
    },
    resetCampos() {
      this.setCodProduto = "";

      this.Produto = {
        Cod: "",
        Desc: "",
      };

      this.loadingdescproduct = "Descrição automática do SAP";

      this.stopLoadingDotsProduct();
    },
  },
  watch: {
    setCodProduto: async function (newValue) {
      if (!newValue || newValue.trim() === "") {
        this.Produto.Cod = "";
        this.Produto.Desc = "";
        this.validationProduct = false;
        if (!this.listaOficial.length) {
          this.loadingdescproduct = "Aguardando";
        } else {
          this.loadingdescproduct = "Descrição automática do SAP";
        }
        this.stopLoadingDotsProduct();
        return;
      }

      this.loadingdescproduct = "Carregando";
      this.startLoadingDotsProduct();
      this.validationProduct = false;

      try {
        const { data: productOne } = await sap.get(`/cod_product`, {
          params: {
            unidade: "JPA",
            cod_product: newValue,
          },
        });

        if (productOne && productOne.descricao_produto) {
          this.Produto.Cod = productOne.codigo_produto;
          this.Produto.Desc = productOne.descricao_produto;
          this.validationProduct = false;
          this.loadingdescproduct = "Descrição automática do SAP";
        } else {
          this.Produto.Desc = "";
          this.validationProduct = true;
          this.loadingdescproduct = "Não encontrado";
          this.stopLoadingDotsProduct();
        }
      } catch (error) {
        console.error("Erro ao buscar o produto:", error);
        this.Produto.Desc = "";
        this.validationProduct = true;
        this.loadingdescproduct = "Erro";
        this.dotsProduct = "";
        this.stopLoadingDotsProduct();
      } finally {
        this.stopLoadingDotsProduct();
      }
    },
    // "setCodMateriaPrima": async function (newValue) {

    //   if(!newValue || newValue.trim() === "") {
    //       this.MateriaPrima.Cod = "";
    //       this.MateriaPrima.Desc = "";
    //       this.validationFeedstock = false;
    //       if (!this.listaOficial.length) {
    //         this.loadingdescfeedstock = "Aguardando";
    //       } else {
    //         this.loadingdescfeedstock = "Descrição";
    //       }

    //       return;
    //   }

    //     this.validationFeedstock = false;
    //     this.startLoadingDotsFeedstock();
    //     this.loadingdescfeedstock = "Carregando"

    //   try {
    //         const { data: feedstockOne } = await sap.get(`/raw-material`, {
    //           params: {
    //             unidade: "JPA",
    //             material_code: newValue,
    //           },
    //         });

    //         if (feedstockOne && feedstockOne.results[0].itemName) {
    //           this.MateriaPrima.Cod = feedstockOne.results[0].itemCode;
    //           this.MateriaPrima.Desc = feedstockOne.results[0].itemName;
    //           this.validationFeedstock = false;
    //           this.loadingdescfeedstock = "Descrição"
    //         }
    //         else {
    //           this.MateriaPrima.Desc = "";
    //           this.validationFeedstock = true;
    //           this.loadingdescfeedstock = "Não encontrado";
    //           this.stopLoadingDotsFeedstock();
    //         }

    //       } catch (error){
    //         console.error("Erro ao buscar a matéria prima:", error);
    //         this.MateriaPrima.Desc = "";
    //         this.validationFeedstock = true;
    //         this.loadingdescfeedstock = "Erro";
    //         this.dotsFeedstock = '';
    //         this.stopLoadingDotsFeedstock();
    //       } finally {
    //         this.stopLoadingDotsFeedstock();
    //       }
    //     }},
  },
};
</script>

<style scoped>
input {
  color: var(--font_color) !important;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.btn-button-produto {
  height: 100%;
  width: 100%;
  cursor: pointer;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--green);
  border-radius: 0.5rem;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
}

.btn-produto {
  height: 2.5rem;
  width: 11rem;
  animation: pulse 0.7s ease-in-out 5;
  display: flex;
  align-items: center;
  margin-top: auto;
  flex-direction: center;
  justify-content: center;
}

.sum {
  background-image: url(../../../../../../static/icons/+.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  height: 1rem !important;
  width: 1rem !important;
}

.btn-button-produto:hover {
  background-color: var(--green_hover);
}

.btn-button-produto:focus {
  background-color: var(--green_focus);
}

.row-1 {
  display: flex;
  gap: 1.5rem;
  align-items: top !important;
  margin-bottom: 10px;
  color: var(--font_color);
  margin-top: -0.5rem;
}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  color: var(--font_color);
}

.field {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9;
  height: 2.5rem !important;

  padding: 1rem;
  color: var(--font_color);
}

.default_field_width {
  width: 17rem !important;
}

.large_field_width {
  width: 25rem !important;
}

.field_select {
  border-radius: 10px !important;
  border: 1px solid #d9d9d9;
  height: 2.5rem !important;
  width: 13rem !important;
  color: var(--font_color);
}

.field:hover {
  border: 1px solid var(--input_hover) !important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green) !important;
}

.field::placeholder {
  color: rgb(65, 62, 62) !important;
}

.one {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.error {
  border-radius: 10px !important;
  padding: 1rem;
  color: var(--font_color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 13rem !important;
  text-align: center !important;
  margin: auto;
}

.btnDelete {
  background-image: url("../../../../../../static/icons/trash.svg") !important;
  background-repeat: no-repeat;
  background-position: center;
  width: 2rem;
}

.btnDelete button {
  width: 2rem !important;
  height: 2rem !important;

  background-color: #d9d9d900;
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  opacity: 0;
  animation: fadeIn 1s ease forwards !important;
}

.table thead tr td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.table thead tr td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.table tbody tr:last-child td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.table tbody tr:last-child td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.table thead td {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
}

.table tbody td {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  padding: 0.5rem;
}

td {
  font-size: 0.8rem;
}

.tableHistorico {
  margin-top: 1rem;
  max-height: 7rem;
  overflow: auto;
}

.header {
  background-color: white;
  color: var(--font_color);
  padding: 1rem 0rem !important;
  border: 1px solid red !important;
}

.header tr td {
  padding: 1rem 0rem !important;
}

.field-table {
  font-size: 0.7rem;
}

.description-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

@media (max-width: 1266px) {
  .row-1 {
    flex-wrap: wrap;
    width: 100% !important;
  }

  .one {
    width: 100%;
    margin-bottom: 1rem;
  }

  .default_field_width,
  .field_select,
  .text-red {
    width: 100% !important;
  }

  .large_field_width {
    width: 100% !important;
  }

  .description-section {
    flex-wrap: wrap;
  }

  .btn-produto {
    width: 13rem;
  }
}

@media (max-width: 1266px) {
  .row-1 {
    display: flex;
    justify-content: center;
  }

  .section-field {
    width: 100%;
  }

  .default_field_width {
    width: 100% !important;
  }

  .field_select {
    width: 30rem !important;
  }

  .text-red {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .tableHistorico table thead {
    display: none;
  }

  .tableHistorico,
  .tableHistorico table,
  .tableHistorico tbody,
  .tableHistorico tr,
  .tableHistorico td {
    display: block;
    width: 100%;
  }

  .tableHistorico tr {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 0.7rem;
    background-color: white;
  }

  .tableHistorico td {
    text-align: right;
    position: relative;
    padding-left: 55%;
    font-size: 0.85rem;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .tableHistorico td:last-child {
    border-bottom: none;
  }

  .tableHistorico td::before {
    content: attr(data-title);
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    color: #555;
    font-size: 0.85rem;
  }
}
</style>
